import { branch } from 'recompose';
import { T, F } from 'ramda';

export const branchShouldRequest = (...args) => {
  if (process.env.REACT_APP_SHOULD_REQUEST === 'true') {
    return branch(T, ...args);
  }
  return branch(F, ...args);
};
